
import { defineComponent } from 'vue';
import SmallCardComponent from '../Cards/SmallCardComp.vue';
import { mapGetters } from 'vuex';
import SmallCardPreloaderComponent from "@/components/Cards/SmallCardPreloaderComp.vue";


export default defineComponent({
	name: 'CatalogCardsComponent',
    components: {
      SmallCardPreloaderComponent,
        SmallCardComponent
    },
    computed: {
        ...mapGetters(["getNoveltyMods", "getCardsPreloaders"])
    }
})
